import { getAuthAxiosBackend } from "../helpers/axios"

class RationCardServices{

    get(id){
        return getAuthAxiosBackend().get('RationCards/getRationCards/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('RationCards/getRationCardsByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('RationCards/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('RationCards/addRationCards', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('RationCards/updateRationCards/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('RationCards/softDeleteRationCards/' + id.toString())
    }
}

export default new RationCardServices()